/* eslint-disable import/no-anonymous-default-export */
import styled from 'styled-components';

const size = 42;

const Row = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
	margin: 25px 30px 30px 0;
`;

const Image = styled.div`
	background-color: ${p => p.theme.colors.border};
	border-radius: ${size / 2}px;
	border: 1px solid #fff;
	margin-left: 8px;
	width: ${size}px;
	height: ${size}px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const Avatar = styled.image`
	width: ${size}px;
	height: ${size}px;
	border-radius: ${size / 2}px;
	border: 1px solid #fff;
`;

export default {
	Row,
	Image,
	Avatar,
};
